import './advance-search.css';
import TextComponent from './text-component'
import formRules from './rules';
import {
    Accordion, Button, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, Tab, Tabs, Paper, AccordionSummary,
    AccordionDetails, Typography, FormControlLabel, Checkbox, FormGroup, Alert
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState, useContext, useEffect } from 'react';
import filter from '../../service/filter';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import api from '../../service/api';
import Result from '../result/result';
import ProgressBar from '../progress/progressBar';
import UserContext from '../../context/user';
import Storage from '../../session/storage';
import CONSTANT from '../../Constant/Constant';
import { UiPicklistContext } from '../../context/UiPicklistContext';

const AdvanceForm = (props) => {
    let localCookies = Storage.getAdvanceName();
    const { uiDropdownValue } = useContext(UiPicklistContext);
    const [strict, setStrict] = useState(true);
    const UserInfo = useContext(UserContext);
    const [form, setForm] = useState(undefined);
    const [advanceParent, setAdvanceParent] = useState(props.parent);
    const [attribute, setAttribute] = useState([]);
    const [relation, setRelation] = useState([]);
    const [showDetailsFlag, setShowDetailFlag] = useState(false);
    const [allDetails, setAllDetails] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [elasticSearchCount, setElasticSearchCount] = useState(0);
    const [error, setError] = useState(false);
    const [accordian, setAccordian] = useState(true);
    const [entity, setEntity] = useState(0);
    const [entityTabs, setEntityTabs] = useState((localCookies && localCookies.entityTabs) ? localCookies.entityTabs : 'HCP');
    const [initialFormHCP, setInitialFormHCP] = useState({ form, accordian, entity, entityTabs, relation });
    const [initialFormHCO, setInitialFormHCO] = useState({ undefined, accordian, entity, entityTabs, relation });
    const [clearFlag, setClearFlag] = useState(false);
    const [dropDownValue, setDropdownValue] = useState([]);
    
    /* Used for the session Mangement */
    useEffect(() => {
        let advanceStorage = Storage.getAdvanceName();
        let oldSession = advanceStorage !== undefined && props.parent !== 'home';
        if (oldSession) {
            setForm(advanceStorage.form);
            setAdvanceParent(props.parent);
            setAttribute(advanceStorage.attribute);
            setEntity(advanceStorage.entity)
            setRelation(advanceStorage.relation);
            setShowDetailFlag(advanceStorage.showDetailsFlag);
            setAllDetails(advanceStorage.allDetails);
            setElasticSearchCount(Storage.getCount() ? Storage.getCount() : 0);
            setEntityTabs(advanceStorage.entityTabs);
            let HCPForm = (advanceStorage.entityTabs === 'HCP' ? advanceStorage.form : undefined)
            let HCOForm = (advanceStorage.entityTabs === 'HCO' ? advanceStorage.form : undefined)
            setInitialFormHCP({ form: HCPForm, accordian: advanceStorage.accordian, entity: advanceStorage.entity, entityTabs: advanceStorage.entityTabs, relation: advanceStorage.relation });
            setInitialFormHCO({ form: HCOForm, accordian: advanceStorage.accordian, entity: advanceStorage.entity, entityTabs: advanceStorage.entityTabs, relation: advanceStorage.relation });
        }
    }, [props.parent])

    useEffect(() => {
        if (uiDropdownValue === undefined || uiDropdownValue === null || uiDropdownValue.length === 0) return;
        setDropdownValue(uiDropdownValue);
    },[uiDropdownValue])

    /* Toggle between HCP & HCO */
    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            setEntityTabs('HCP');
            setInitialFormHCO({ form, accordian, entity, entityTabs, relation });
            setForm(initialFormHCP !== undefined ? (initialFormHCP.form) : initialFormHCP);
            setRelation(initialFormHCP.Relation)
        } else {
            setEntityTabs('HCO');
            setInitialFormHCP({ form, accordian, entity, entityTabs, relation });
            setForm(initialFormHCO !== undefined ? (initialFormHCO.form) : initialFormHCO);
            setRelation(initialFormHCP.Relation)
        }
        setEntity(newValue);

    };

    /* 
    Creating the Advance Form Object
    @Params event : Object  having value and name of attribute    
    */
    const parentText = (event) => {

        setForm((prevState) => {
            return (
                {
                    ...prevState,
                    [event.target.name]: event.target.value
                }
            )
        });
        setClearFlag(false);

    }

    /* 
    
    */
    const submitForm = async () => {
        
        form && Object.keys(form).forEach(key => {
            if (((!(form[key] instanceof Array))
                && (form[key].trim()?.length === 0 || form[key] === undefined)) ||
                ((form[key] instanceof Array) && form[key]?.length === 0)) {
                delete form[key];
            }
        });
        form && Object.keys(form).forEach(key => {
            if (key.split('.')[0] === 'operation') {
                let operation = form[key];
                let operationName = '';
                let firstLoop = true;
                key.split('.').forEach((operationNameValue, i) => {

                    if (i !== 0) {
                        operationName += firstLoop ? operationNameValue : '.' + operationNameValue;
                        firstLoop = false;
                    }
                })
                let opreationValue = form[operationName];
                if (!operation || !opreationValue) {
                    delete form[key]
                }
            }
        });
        if (form) {

            if (Object.keys(form)?.length === 0) {
                setError(true);
            } else {
                window.scroll(0,0)
                setIsLoading(true);
                let resultQuery = [];
                let relationResultQuery = [];
                let operationQuery = '';
                let relationQuery = '';
                let firstRelationFlag = true;
                let attributeFlag = true;
                let country = [];
                if (props.dualSearch === true) {
                    resultQuery.push(props.globalForm.searchtext);
                }
                Object.keys(form).forEach((key, i) => {
                    if (key.split('.')[0] !== 'operation' && key.split('.')[0] !== 'Relation') {
                        let operation = 'operation.' + key;
                        let operationValue = 'Equals';
                        if (form[key]?.length !== 0) {
                            let attributeValue;
                            if (CONSTANT.ADVANCE_SEARCH_MAP_KEY.includes(key) && !['Exists', 'Not Exists'].includes(form[operation])) {
                                attributeValue = form[key].map((source) => {
                                    return source.split('[')[0].trim();
                                })
                            } else {
                                attributeValue = form[key];
                            }
                            operationValue = form[operation] ? form[operation] : operationValue;
                            resultQuery.push(key + " " + filter.getSymbols(operationValue) + " " + (['Exists', 'Not Exists'].includes(operationValue) ? '' : form[key]));
                            operationQuery = (attributeFlag) ? (operationQuery + '' + filter.convertInToQuery(key, attributeValue, operationValue)) : (operationQuery + ' and ' + filter.convertInToQuery(key, attributeValue, operationValue));
                            attributeFlag = false;

                        }
                    }
                    else if (key.split('.')[0] === 'Relation') {
                        let operation = 'operation.' + key;
                        let operationValue = 'Equals';
                        if (form[key]?.length !== 0) {
                            operationValue = form[operation] ? form[operation] : operationValue;
                            relationResultQuery.push(key + " " + filter.getSymbols(operationValue) + " " + (['Exists', 'Not Exists'].includes(operationValue) ? '' : form[key]))
                            relationQuery = (firstRelationFlag) ? (relationQuery + '' + filter.convertInToQuery(key, form[key], operationValue)) : (relationQuery + ' and ' + filter.convertInToQuery(key, form[key], operationValue));
                            firstRelationFlag = false;
                        }
                    }
                });
                setAttribute(resultQuery);
                setRelation(relationResultQuery)

                if (props.dualSearch === true) {
                    props.globalForm.entity && props.globalForm.entity?.length !== 0 && props.globalForm.entity.forEach((value) => {
                        if (value.type !== 'Entity') {
                            if (!country.includes(value.name)) {
                                country.push(value.name);
                                resultQuery.push(value.name);
                            }
                        }
                    })
                }
                country = country?.length === 0 ? UserInfo.countries : country;
                await api.getAdvanceSearchCount(entityTabs, operationQuery, relationQuery, country, props.dualSearch === true ? props.globalForm.searchtext : '', strict).then(async (res) => {
                    Storage.setCount(res.data.total.count)
                    setElasticSearchCount(res.data.total.count);
                }).catch((error) => {
                    setElasticSearchCount(0);
                })
                api.getAdvanceSearch(entityTabs, operationQuery, relationQuery, country, props.dualSearch === true ? props.globalForm.searchtext : '', strict).then(async (respons) => {
                    let apiResponse = JSON.parse(JSON.stringify(respons));
                    await setAllDetails(apiResponse.data);
                    await setShowDetailFlag(true);
                    setIsLoading(false)
                    if (entityTabs === 'HCP') {
                        setInitialFormHCP({ form, accordian, entity, entityTabs });
                    } else {
                        setInitialFormHCO({ form, accordian, entity, entityTabs });
                    }
                    setAdvanceParent('global')
                    setStateCookie(apiResponse.data, true, resultQuery, relationResultQuery);
                }).catch((error) => {
                    setIsLoading(false)
                    if (entityTabs === 'HCP') {
                        setForm(initialFormHCP.form)
                        setAccordian(initialFormHCP.accordian)
                    } else {
                        setForm(initialFormHCO.form)
                        setAccordian(initialFormHCP.accordian)
                    }
                });

            }


        } else {
            setError(true);
        }

    }

    /* 
    Handels Accordian Expand funtionality  
    */
    const closeAccordian = (prevState) => {
        setAccordian(!prevState);
        if (entityTabs === 'HCP') {
            setInitialFormHCP({ form, accordian, entity, entityTabs });
        } else {
            setInitialFormHCO({ form, accordian, entity, entityTabs });
        }

    }

    /*
    Gives the Operation Dropdown Values for Date
    */
    const getDateOptions = () => {
        return [{ key: 'Equals', value: 'Equals' }, { key: "Not Equals", value: "Not Equals" }, { key: 'Less Than', value: 'Less Than' }, { key: 'Greater Than', value: 'Greater Than' }, { key: 'In Range', value: 'In Range' }, { key: 'Not Exists', value: 'Not Exists' }, { key: 'Exists', value: 'Exists' }];
    }

    /*
    Gives the Operation Dropdown Values for String
    */
    const getStringOptions = () => {
        return [{ key: "Equals", value: "Equals" }, { key: "Not Equals", value: "Not Equals" }, { key: "Exists", value: "Exists" }, { key: "Not Exists", value: "Not Exists" }, { key: "Contains", value: "Contains" }];
    }

    /*
    Gives the Operation Dropdown Values for Numer
    */
    const getNumberOptions = () => {
        return [{ key: "Equals", value: "Equals" }, { key: "Not Equals", value: "Not Equals" }, { key: "Less Than", value: "Less Than" }, { key: "Greater Than", value: "Greater Than" }, { key: 'In Range', value: 'In Range' }, { key: 'Not Exists', value: 'Not Exists' }, { key: 'Exists', value: 'Exists' }];
    }

    /*
    Gives the Operation Dropdown Values for Boolean
    */
    const getBooleanOption = () => {
        return [{ key: "Equals", value: "Equals" }, { key: "Not Equals", value: "Not Equals" }, { key: 'Not Exists', value: 'Not Exists' }, { key: 'Exists', value: 'Exists' }];

    }

    /*
    Used to close the Popup
    */
    const handleClose = () => {
        setError(false);
    }

    /*
        It will display the detail view of HCP / HCO
        @details : detail of particular HCP or HCO 
    */
    const goToDetails = (details) => {
        const query = details._id + '&' + details._source?.type.split('/')[2];
        props.history.push("/details/" + query);
    }

    /*
    Change the Advance form to initial State
    */
    const changeToDefault = () => {

        if (entityTabs === 'HCP') {
            setForm(initialFormHCP.form);
            setAccordian(initialFormHCP.accordian);
        } else {
            setForm(initialFormHCO.form);
            setAccordian(initialFormHCO.accordian);
        }
        setShowDetailFlag(false);
    }
	
	const vendorSearchPopup = (data) => {        
        props.vendorSearch(data)
    }

   
    /*
    Open's Result Page
    */
    const goToResult = () => {
        if (allDetails === undefined) {
            props.showResult();
        } else {
            setShowDetailFlag(true);
        }

    }

    /*
    Goes back To Home Page
    */
    const refreshPage = () => {
        props.getBackToHome();
    }

    /* Shows Advance Form*/
    const showAdvanceSearch = () => {
        setShowDetailFlag(false);
    }

    /*
    Storing Session Cookies
    */
    const setStateCookie = (details, flag, sessionAttribute, sessionRelation) => {
        Storage.setAdvanceName({
            allDetails: details,
            form: form,
            entityTabs,
            entity,
            showDetailsFlag: flag,
            attribute: sessionAttribute,
            relation: sessionRelation,
            elasticSearchCount: elasticSearchCount
        });
        props.setGlobalSession()
    }

    /*Get Back to Home */
    const home = () => {
        props.getBackToHome();
    }

    /*Clear All in Form */
    const clearAll = () => {
        
        setClearFlag(true);
        setIsLoading(true);
        setForm(undefined);
        setInitialFormHCO({ form: undefined, accordian, entity, entityTabs });
        setInitialFormHCP({ form: undefined, accordian, entity, entityTabs });
        let intervalId = setTimeout(() => {
            setClearFlag(false);
            setIsLoading(false);
            clearTimeout(intervalId)
        }, 1000)
    }

    return (
        <>

            <div className={!showDetailsFlag ?
                "container  min-width w-75 mb-5  body-height extra-margin-top-less" :
                "container  min-width w-100 mb-5  body-height extra-margin-top-less"
            }>                
                {
                    showDetailsFlag &&
                    <Result parent={'globalState'}
                        relation={relation}
                        attribute={attribute}
                        entityTabs={entityTabs}
                        form={form}
                        result={allDetails.result}
                        count={elasticSearchCount}
                        getback={() => changeToDefault()}
                        goToDetails={(details) => goToDetails(details)}
                        showAdvanceSearch={() => showAdvanceSearch()}
                        goToHome={() => home()}
                        history={props.history}
                        lillyCountry={props.lillyCountry}
						vendorSearch={(data) => vendorSearchPopup(data)}
                    />
                }
                {
                    isLoading && 
                    <div className="d-flex justify-content-center extra-margin-top">
                        <ProgressBar />
                    </div>
                }               
                {
                    !showDetailsFlag && !isLoading &&
                    <>
                        <div className='container-fluid'>
                            {
                                advanceParent === 'home' &&
                                <IconButton aria-label="delete " onClick={refreshPage} className=' float-end'
                                    color="secondary">
                                    <CancelIcon className="text-danger "
                                    />
                                </IconButton>
                            }
                            {
                                advanceParent === 'global' &&
                                <IconButton aria-label="delete " onClick={goToResult} className=' float-end'
                                    color="secondary">
                                    <CancelIcon className="text-danger "
                                    />
                                </IconButton>
                            }
                        </div>
                        <Paper square>
                            <Tabs
                                value={entity}
                                indicatorColor="primary"
                                textColor="primary"
                                onChange={handleChange}
                                aria-label="disabled tabs example"
                            >
                                <Tab label="HCP" />
                                <Tab label="HCO" />

                            </Tabs>


                        </Paper>

                        <Accordion square className="shadow-md" expanded={accordian}>
                            <AccordionSummary onClick={() => closeAccordian(accordian)}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="FirstName"
                            >
                                <Typography  id="advance-tab">{formRules[0].key}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className=" container w-100 p-3 pt-0">
                                    {
                                        formRules[0].value.map((data, key) => {
                                            let fieldOptions = [];
                                            let options = [];
                                            options = data.type === 'url' ? getStringOptions() : options;
                                            options = data.type === 'string' ? getStringOptions() : options;
                                            options = data.type === 'number' ? getNumberOptions() : options;
                                            options = data.type === 'boolean' ? getBooleanOption() : options;
                                            let optionJSON = JSON.parse(JSON.stringify(dropDownValue.length > 0 ?  dropDownValue[entityTabs] : Storage.getPickList()[entityTabs]));
                                            
                                            let lookup = data.lookup;
                                            if (data.element.toUpperCase() === 'SELECT' && data.type === 'string') {
                                                options = options.filter(option => option.value !== 'Contains')
                                            }
                                            if (data.multi !== undefined) {
                                                options = options.filter(option => option.value !== 'Not Equals')
                                            }
                                            if (CONSTANT.STRICT_ATTRIBUE.includes(data.id) && !strict) {
                                                options = options.filter(option => option.value !== 'Contains')
                                            }

                                            fieldOptions = lookup ? optionJSON[lookup] : fieldOptions;

                                            return (
                                                <TextComponent
                                                    clear={clearFlag}
                                                    form={form}
                                                    type={data.element}
                                                    key={key}                                                    
                                                    fieldOption={fieldOptions}
                                                    operationId={"operation." + data.id}
                                                    name={data.name}
                                                    handeltextChange={parentText}
                                                    value={data.value}
                                                    operations={options}
                                                    id={data.id}
                                                    dataType={data.entity}
                                                    entity={entityTabs}
                                                    changeClear={() => { setClearFlag(false) }}
                                                    className="advance-tab"
                                                />

                                            )
                                        })
                                    }
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {
                            formRules.map((details, key) => {
                                return (
                                    key !== 0
                                    &&
                                    <Accordion key={key} className="shadow-md" >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="FirstName"
                                        >
                                            <Typography id="advance-tab">{details.key}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className=" container w-100 p-3 pt-0">
                                                {
                                                    details.value.map((data, key) => {
                                                        let fieldOptions = [];
                                                        let options = [];
                                                        let userCountryValidation = ['CountryCode'];
                                                        options = data.type === 'date' ? getDateOptions() : options;
                                                        options = data.type === 'string' ? getStringOptions() : options;
                                                        options = data.type === 'number' ? getNumberOptions() : options;
                                                        options = data.type === 'boolean' ? getBooleanOption() : options;

                                                        let optionJSON = JSON.parse(JSON.stringify(dropDownValue.length > 0 ?  dropDownValue[entityTabs] : Storage.getPickList()[entityTabs]));
                                                        let lookup = data.lookup;
                                                        fieldOptions = lookup ? optionJSON[lookup] : fieldOptions;
                                                        fieldOptions = data.type === 'boolean' ? ['Y', 'N'] : fieldOptions;
                                                        fieldOptions = lookup === 'AltIDSubType' ? optionJSON.AltIDSubtype : fieldOptions;
                                                        fieldOptions = fieldOptions === undefined ? [] : fieldOptions;
                                                        if (lookup === "RelationshipType"){
                                                            fieldOptions = Object.values(fieldOptions).flat()
                                                            fieldOptions = [...new Set(fieldOptions.map(item=>[item.split('|')[0].trim(), item.split('|')[1].trim()].join(' | ')))]
                                                        }
                                                        if (userCountryValidation.includes(data.id)) {
                                                            fieldOptions = (UserInfo ? (UserInfo.countries[0] === 'global' ? fieldOptions : JSON.parse(JSON.stringify(UserInfo.countries))) : [])
                                                        }

                                                        if (data.element.toUpperCase() === 'SELECT' && data.type === 'string') {
                                                            options = options.filter(option => option.value !== 'Contains')
                                                        }
                                                        if (data.multi !== undefined) {
                                                            options = options.filter(option => option.value !== 'Not Equals')
                                                        }
                                                        if (CONSTANT.STRICT_ATTRIBUE.includes(data.id) && !strict) {
                                                            options = options.filter(option => option.value !== 'Contains')
                                                        }
                                                        return (
                                                            <TextComponent
                                                                clear={clearFlag}
                                                                form={form}
                                                                key={key}
                                                                type={data.element}
                                                                fieldOption={fieldOptions.sort()}
                                                                operationId={"operation." + data.id}
                                                                name={data.name}
                                                                handeltextChange={parentText}
                                                                value={data.value}
                                                                operations={options}
                                                                id={data.id}
                                                                dataType={data.entity}
                                                                entity={entityTabs}
                                                                
                                                            />

                                                        )
                                                    })
                                                }
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            })
                        }
                        <FormGroup row className='mt-3'>
                            <FormControlLabel className='float-end'
                                control={<Checkbox checked={strict} onChange={() => setStrict(!strict)} name="Strict" />}
                                label="Strict Searching"  id="tooltip"
                            />
                        </FormGroup>
                        <DialogActions className='_wg-dynamic-text' sx={{display: 'flex', justifyContent:'center', alignItems:'center'}}>
                                <Button onClick={clearAll} color="error" variant="outlined" id="advance-action">
                                    CLEAR ALL
                                </Button>
                                <Button onClick={submitForm} color="error" variant="contained" id="advance-action">
                                    SEARCH
                                </Button>
                            </DialogActions>
                        <Dialog
                            open={error}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="dialog-title" color='primary'>{"Warning"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="dialog-content">
                                    Please Input At least One Filter !
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions sx={{mr: '15px'}} className='_wg-dynamic-text'>
                                <Button onClick={handleClose} color="error" variant="outlined" autoFocus>
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>
                }
                {
                             (elasticSearchCount === 0 && showDetailsFlag && !isLoading) &&
                             <>
                            <div className="container d-flex justify-content-center">
                                <Alert severity="success" className="w-70 justify-content-center text-center" color="info">
                                <span className="zero-record">  <strong>0</strong> Records Found. Please Refine Your Search.</span>
                                </Alert>
                            </div>                             
                            </>
                        }
            </div >
        </>
    )



}


export default AdvanceForm;